import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GrievanceServiceService } from 'src/app/Services/grievance-service.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/Services/auth.service';
import { TokenService } from 'src/app/Services/token.service';

@Component({
  selector: 'app-grievance',
  templateUrl: './grievance.component.html',
  styleUrls: ['./grievance.component.scss']
})
export class GrievanceComponent implements OnInit {
  grievanceForm: FormGroup;
  fileInputLabel:any;
  upload:any;
  userDetails:any=[];
  natures:any=[];
  public loggedIn: boolean = false;

  constructor(
    private token: TokenService,
    private auth: AuthService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private grievanceService: GrievanceServiceService,
    private router: Router
    ) { }

  ngOnInit(): void {
    this.auth.authStatus.subscribe((value) => (this.loggedIn = value));
    this.getGrivancesNature();
    this.createForm();
    this.getUser();
  }

  logout(event: MouseEvent) {
    event.preventDefault();
    this.token.remove();
    this.auth.changeStatus(false);
    this.auth.logout();
    window.location.replace('/login');
  }

  getGrivancesNature(){
    this.grievanceService.getGrivancesNature().subscribe(data=>this.natures=data['natures']);
  }

  createForm(){
    this.grievanceForm = this.formBuilder.group({
      name: [
        null,
        Validators.compose([
          Validators.required,
          // Validators.pattern('^[a-zA-Z. ]*$'),
          Validators.minLength(3)])
        ],
      email: [
        null,
        Validators.compose(
          [Validators.required,
          Validators.email,
          Validators.pattern('^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$')])
      ],
      phone: [
        null,
        Validators.compose([
          Validators.maxLength(10),
          Validators.minLength(10),
          Validators.pattern('[56789][0-9]{9}'),
        ]),
      ],
      nature: [null, Validators.required],
      subject: [null, Validators.required],
      attachment: [null],
      message: [null, Validators.compose([Validators.required])],
    });
  }

  getUser(){
    this.grievanceService.getUser().subscribe(data=>this.setUser(data));
  }

  setUser(data){
    this.userDetails = data['user'];
    this.grievanceForm.controls.name.setValue(this.userDetails['first_name']);
    this.grievanceForm.controls.email.setValue(this.userDetails['email']);
    this.grievanceForm.controls.phone.setValue(this.userDetails['phone']);
  }

  onSubmit(data) {
    if(this.grievanceForm.valid){
      var upload_data=new FormData();
      upload_data.append('name',this.grievanceForm.controls.name.value);
      upload_data.append('email',btoa(this.grievanceForm.controls.email.value));
      upload_data.append('phone',this.grievanceForm.controls.phone.value);
      upload_data.append('nature',this.grievanceForm.controls.nature.value);
      upload_data.append('subject',this.grievanceForm.controls.subject.value);
      upload_data.append('message',this.grievanceForm.controls.message.value);
      if(this.upload){
        upload_data.append('file',this.upload);
      }
      this.grievanceService.createGrievance(upload_data).subscribe(response=>this.handleResponse(response))
    }else{
      this.toastr.error("Fill all the details carefully.")
    }

  }

  handleResponse(data) {
    if (data['type'] == "Success") {
      this.toastr.success(data['message']);
      this.routeBack();
    } else {
      this.toastr.error(data['message'])
    }
  }

  routeBack(){
    this.router.navigateByUrl('grievanceTable');
    // switch(this.userDetails['role']){
    //   case 'Expert': this.router.navigateByUrl('expert'); break;
    //   case 'Moderator': this.router.navigateByUrl('moderator'); break;
    //   case 'Institute': this.router.navigateByUrl('institute'); break;
    //   case 'Student': this.router.navigateByUrl('student'); break;
    //   case 'HOD': this.router.navigateByUrl('hod'); break;
    //   case 'Faculty': this.router.navigateByUrl('faculty'); break;
    // }
  }

  uploadedFile(event){
    if(event.target.files && event.target.files[0]){
      
      // Check for double extension
      if(this.auth.checkDoubleExtension(event.target.files[0].name) == 0) {
        this.toastr.error("Filename with two extensions is not supported.");
        this.upload = null;
        return;
      }

      this.upload=event.target.files[0];
      this.fileInputLabel=this.upload.name;
    }
  }

  checkPhoneNumber(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  isDotKey(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode == 46) {
      return false;
    }
    return true;
  }
}
